import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { LogIn, Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.role !== "admin") {
        toast.error("Account non autorizzato all'area amministratore");
        return;
      }
      await refresh();
      toast.success("Accesso effettuato");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-6 py-16 bg-bg">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-white border border-line rounded-lg shadow-card p-8"
      >
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-brand/10 text-brand rounded-full text-[11px] font-display uppercase tracking-[0.2em]">
          <Lock className="w-3 h-3" /> Area riservata
        </div>
        <h1 className="mt-3 font-display text-3xl text-ink">
          Accesso <span className="text-brand">amministratore</span>
        </h1>
        <p className="mt-2 text-sm text-ink-muted">
          Pannello di gestione dossier — Studio Ingegneria Valore.
        </p>

        <div className="mt-8 space-y-4">
          <label className="block">
            <span className="block text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-1.5">
              Email
            </span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email"
              autoComplete="username"
              className="w-full h-11 px-3 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-brand/20 focus:border-brand text-sm"
            />
          </label>
          <label className="block">
            <span className="block text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-1.5">
              Password
            </span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password"
              autoComplete="current-password"
              className="w-full h-11 px-3 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-brand/20 focus:border-brand text-sm"
            />
          </label>
        </div>

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-6 w-full h-11 bg-brand text-white font-display uppercase tracking-widest text-sm rounded-md hover:bg-brand-dark hover:shadow-brand-glow disabled:opacity-60 flex items-center justify-center gap-2"
        >
          <LogIn className="w-4 h-4" />
          {loading ? "Accesso..." : "Accedi"}
        </button>
      </form>
    </div>
  );
}
